/** Keep in sync with server/constants/listingLease.js */
export const LISTING_LEASE_VERSION = 'v1';

// ParkPro's standing counter-signature on Section 12 of the Host Parking
// License & Platform Agreement (PP-543) — a fixed officer signature, not
// something captured per-submission, so there's no server-side copy of
// this to stay in sync with.
export const PARKPRO_SIGNATORY_NAME = 'Tra Williams';
export const PARKPRO_SIGNATORY_TITLE = 'President';
